import { z } from "zod";

export const projectWorkforceItemSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const projectWorkforcesResponseSchema = z.object({
  results: z.array(projectWorkforceItemSchema),
});

export type ProjectWorkforceItem = z.infer<typeof projectWorkforceItemSchema>;
export type ProjectWorkforcesResponse = z.infer<typeof projectWorkforcesResponseSchema>;
